import React from 'react';
import Button from '@material-ui/core/Button';
import ToggleButton from '@material-ui/lab/ToggleButton';
import ToggleButtonGroup from '@material-ui/lab/ToggleButtonGroup';
import { checkValidEmail } from '../../helpers';
import SelectionList from '../SelectionList';
import NavigationTabs from '../nav/NavigationTabs';
import { ASSIGN_MOBILE_CLIENTS_MESSAGE } from '../../static-content';
import ClientsListing from './ClientsListing';
import { COLORS } from '../../styles/colors';
import Modal from '@material-ui/core/Modal';
import ModalHeading from './../../components/ModalHeading';
import Moment from 'react-moment';
import { AlertJsMessage, paginationLimit } from './../../helpers.js';
import { resetBlock } from '../../store/actions/blocks';


class ClientsForm extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			categoryId: '0',
			tab: 0,
			search: '',
			itemType: 'workout',
			clientType: 'clients',
			assigns: [],
			dataLoaded: false,
			openAddModal: false,
			newGroupName: '',
			selectedItems: {},
			openAlreadyAssignModal: false,
			alreadyAssignedList: [],
			editData: undefined,
			newClientId: null,
			seltectedClients: {},
			seltectedGroups: {},
			formData: {
				groupIds: [],
				clientIds: [],
				emails: '',
				message: '',
				firstName: '',
				lastName: '',
				_id: undefined,
			},
			isOpenActionModal: false
		};
	}

	componentDidMount() {
		this.props.fetch().then(() => {
			this.fetchListing({})
		});
	}

	fetchListing = (query) => {
		const func = this.state.clientType === 'clients' ?
				this.props.fetchClients
				: this.props.fetchGroups;
		func({
			limit: paginationLimit.TEN,
			skip: query.skip ? query.skip : 0,
			search: query.search
		}).then((data) => {
		  this.setState({
			...this.state,
			dataLoaded: true,
		  })
		});
	};

	createGroupSubmit(newGroupName, formData) {
		if (!newGroupName.trim()) {
			AlertJsMessage('Please Insert a new Group Name.');
			return;
		}
		if (!this.validateEmails()) {
			return;
		}
		this.createGroup(newGroupName, formData);
	}

	saveData = () => {
		const { newGroupName, formData, clientType } = this.state;
		this.setState({ newClientId: null });
		if (clientType === 'groups') {
			this.createGroupSubmit(newGroupName, formData);
		} else if (clientType === 'clients') {
			const required = ['firstName', 'lastName'];
			for (var i = 0; i < required.length; i++) {
				if (!formData[required[i]]) {
					AlertJsMessage(
						required[i] === 'firstName'
							? 'First Name is required.'
							: 'Last Name is required.'
					);
					return;
				}
			}
			if (!this.validateEmails()) {
				return;
			}
			this.createClient(formData);
		}
	};

	createGroup = (newGroupName, formData) => {
		const { user, createGroup } = this.props;
		const newGroupData = {
			trainerId: user._id,
			name: newGroupName,
			emails: formData.emails.split(','),
		};
		if (formData._id) {
			newGroupData._id = formData._id;
		}
		createGroup(newGroupData).then(newGroup => {
			//after saving the group, then update the list and select the new group
			let seltectedGroups = this.state.seltectedGroups;
			seltectedGroups[newGroup._id.toString()] = newGroup;
			this.setState(
				{
					clientType: 'groups',
					newClientId: newGroup._id,
					seltectedGroups:seltectedGroups,
					formData: {
						...this.state.formData,
						emails: '',
						groupIds: [
							...this.state.formData.groupIds,
							newGroup._id.toString(),
						],
					},
				},
				() => {
					this.hideAddModal();
					this.fetchListing({});
				}
			);
		});
	};

	createClient = formData => {
		const { user, createClient } = this.props;
		const newClientData = {
			trainerId: user._id,
			firstName: formData.firstName,
			lastName: formData.lastName,
			email: formData.emails.split(',')[0],
		};
		if (formData._id) {
			newClientData._id = formData._id;
		}
		createClient(newClientData).then(newClient => {

			let seltectedClients = this.state.seltectedClients;
			seltectedClients[newClient._id.toString()] = newClient;

			this.setState(
				{
					clientType: 'clients',
					newClientId: newClient._id,
					seltectedClients: seltectedClients,
					formData: {
						...this.state.formData,
						emails: '',
						clientIds: [
							...this.state.formData.clientIds,
							newClient._id.toString(),
						],
					},
				},
				() => {
					this.hideAddModal();
					this.fetchListing({});
				}
			);
		});
	};

	handleFormChecks = (field, data) => event => {
		const { formData } = this.state;
		const { checked, value } = event.target;

		let newList = formData[field];

		if (checked) {
			newList.push(value);
		} else {
			newList = newList.filter(id => {
				return id !== value;
			});
		}

		let { seltectedClients, seltectedGroups } = this.state;
		if (field === 'clientIds') {
			if (checked) {
				if (this.props.clients[value]) {
					seltectedClients[value] = this.props.clients[value];
				}
			} else {
				delete seltectedClients[value]
			}
		}

		if (field === 'groupIds') {
			if (checked) {
				if (this.props.groups[value]) {
					seltectedGroups[value] = this.props.groups[value];
				}
			} else {
				delete seltectedGroups[value]
			}
		}

		this.setState({
			...this.state,
			seltectedClients,
			seltectedGroups,
			formData: {
				...formData,
				[field]: newList
			},
		});
	};

	handleChange = event => {
		const { name, value } = event.target;
		if (name === 'groupName') {
			this.setState({ newGroupName: value });
			return;
		}
		this.setState({
			formData: {
				...this.state.formData,
				[name]: value,
			},
		});
	};

	validateEmails(type) {
		const { formData, clientType } = this.state;
		let returnObj = true;
		if (formData.emails !== '') {
			const emailArr = formData.emails.split(',');
			const errorMail = emailArr.filter(email => !checkValidEmail(email));
			if (errorMail.length > 0) {
				AlertJsMessage(
					`The following emails are invalid. Please resolve before continuing. Note that spaces and line breaks are not allowed in email list. [${errorMail.toString()}]`
				);
				returnObj = false;
			}
		} else {
			AlertJsMessage(
				clientType === 'clients'
					? `Please add client email to save as a client.`
					: `Please add client emails to save as a group. Note that spaces and line breaks are not allowed in email list.`
			);
			returnObj = false;
		}
		return returnObj;
	}

	closeAssignModal() {
		this.setState({
			openAlreadyAssignModal: false,
		});
		const { history } = this.props;
		const { itemType } = this.state;
		if (itemType === 'program') {
			history.push('/assignments/programs');
		} else {
			history.push('/assignments/workout');
		}
	}

	saveAssignData(assigns) {
		const { itemType } = this.state;
		const { history } = this.props;
		this.props.assignEmails(assigns).then(data => {
			if (data.length > 0) {
				let list = [];
				let uniqueItems = [];
				data.forEach(item => {
					const _id = item.workoutId;
					if (uniqueItems.indexOf(_id) < 0) {
						uniqueItems.push(_id);
						list.push({
							_id: _id,
							name: item.name,
							item: [item],
						});
					} else {
						const findIndex = list.findIndex(item => {
							return item._id === _id;
						});
						const filterItem = list[findIndex]['item'];
						filterItem.push(item);
						list[findIndex]['item'] = filterItem;
					}
				});
				this.setState({
					alreadyAssignedList: list,
					openAlreadyAssignModal: true,
				});
			} else {
				if (itemType === 'program') {
					history.push('/assignments/programs');
				} else {
					history.push('/assignments/workout');
				}
			}
		});
	}

	submitForm() {
		const { selectedItems, itemType, formData, seltectedClients, seltectedGroups } = this.state;
		const { user, groups, clients } = this.props;
		let selectedIds = Object.keys(selectedItems);
		if (selectedIds.length < 1) {
			AlertJsMessage(
				'Please select a ' + itemType + ' from the list to continue.'
			);
			return;
		}
		let assigns = [];
		const emailArr = formData.emails.split(',');
		if (formData.emails.trim()) {
			if (!this.validateEmails()) return;
			emailArr.map(email => {
				return selectedIds.map(id => {
					return assigns.push({
						type: itemType,
						typeId: id,
						trainerId: user._id,
						clientEmail: email,
						name: selectedItems[id]['name'],
						message: formData.message,
					});
				});
			});
		} else if (formData.groupIds.length > 0) {
			formData.groupIds.map(groupId => {
				const group = seltectedGroups[groupId];
				return group && group.emails.map(email => {
					return selectedIds.map(id => {
						return assigns.push({
							type: itemType,
							typeId: id,
							trainerId: user._id,
							clientEmail: email,
							name: selectedItems[id]['name'],
							message: formData.message,
						});
					});
				});
				// groups[groupId].emails.map()
			});
	} else if (formData.clientIds.length > 0) {
			formData.clientIds.map(clientId => {
				const client = seltectedClients[clientId];
				return selectedIds.map(id => {
					return assigns.push({
						type: itemType,
						typeId: id,
						trainerId: user._id,
						clientEmail: client && client['email'],
						name: selectedItems[id]['name'],
						message: formData.message,
					});
				});
				// groups[groupId].emails.map()
			});
		} else {
			AlertJsMessage('No clients were selected.');
			return;
		}
		this.saveAssignData(assigns);
	}

	handleToggleClient = (event, type) => {
		if (type) {
			this.setState({
				clientType: type,
				newClientId: null
			}, () => {
				this.fetchListing({});
			});
		}
	};

	handleToggleType = (event, type) => {
		if (type) {
			this.setState({
				...this.state,
				selectedItems: {},
				itemType: type,
			});
		}
	};

	showAddModal = data => {
		if (data) {
			this.setState({
				newGroupName: data.name,
				formData: {
					...this.state.formData,
					emails: data.emails ? data.emails.join(',') : data.email,
					message: '',
					firstName: data.firstName,
					lastName: data.lastName,
					_id: data._id,
				},
				isOpenAddModal: true,
			});
		} else {
			this.setState({
				newGroupName: '',
				formData: {
					...this.state.formData,
					emails: '',
					message: '',
					firstName: '',
					lastName: '',
					_id: undefined,
				},
				isOpenAddModal: true,
			});
		}
	};

	showActionModal = data => {
		this.setState({
			isOpenActionModal: true,
			selectedClientEmail: data.email
		})
	}

	hideActionModal = () => this.setState({ isOpenActionModal: false });

	hideAddModal = () => this.setState({ isOpenAddModal: false });

	renderSelectionList() {
		const { itemType, selectedItems, dataLoaded } = this.state;
		if (dataLoaded) {
			const { workouts, programs, user, workoutCats, programCats, isLoadMoreWorkouts, isLoadMorePrograms, resetWorkouts, resetPrograms } = this.props;
			let items =
				this.state.itemType === 'workout'
					? Object.values(workouts)
					: Object.values(programs);
			let cats =
				this.state.itemType === 'workout'
					? Object.values(workoutCats)
					: Object.values(programCats);
		   let isLoadMore = this.state.itemType === 'workout' ? isLoadMoreWorkouts: isLoadMorePrograms;
			return (
				<SelectionList
					addSelectedClass={true}
					hideTabs={[1,2]}
					itemType={itemType}
					maxListHeight={300}
					items={items}
					selectedItems={selectedItems}
					updateSelectedItems={selected => {
						this.setState({ ...this.state, selectedItems: selected })
					}}
					categories={cats}
					categoryField="categoryId"
					creatorTabs={true}
					fetchMore = {this.props.fetchMore}
					resetListing = { this.state.itemType === 'workout' ? resetWorkouts : resetPrograms}
                 	isLoadMore = {isLoadMore}
					isClientForm = {true}
					user={user}
				/>
			);
		}
		return null;
	}

	render() {

		const {
			clientType,
			itemType,
			formData,
			isOpenAddModal,
			isOpenActionModal,
			alreadyAssignedList,
			openAlreadyAssignModal,
			selectedClientEmail,
			newGroupName,
			newClientId,
		} = this.state;
		const { groups, clients } = this.props;
		return (
			<div>

				<div
					style={{
						marginTop: 5,
						display: 'flex'
					}}
				>
					<div
						style={{
							width: '100%',
							padding: 10,
						}}
						>
						<p style={{ paddingBottom: 10 }}>
							{ASSIGN_MOBILE_CLIENTS_MESSAGE}
						</p>
						<ClientsListing
							clientType={clientType}
							isMobile = { true }
							formData={formData}
							isOpenAddModal={isOpenAddModal}
							isOpenActionModal = {isOpenActionModal}
							showAddModal={this.showAddModal}
							showActionModal = { this.showActionModal}
							selectedClientEmail = { selectedClientEmail}
							hideAddModal={this.hideAddModal}
							hideActionModal = { this.hideActionModal}
							newGroupName={newGroupName}
							groups={Object.values(groups)}
							clients={Object.values(clients)}
							onSave={this.saveData}
							onChange={this.handleChange}
							onChangeGroupIds={type => this.handleFormChecks(type)}
							newClientId={newClientId}
							fetchMore= { this.fetchListing }
							fetchActions = {this.props.fetchActions}
							fetchMileStones = { this.props.fetchMileStones }
							fetchScheduleCall = { this.props.fetchScheduleCall }
							saveBodyMatrix = {this.props.saveBodyMatrix}
							fetchPARQS = { this.props.fetchPARQS }
							savePARQ = { this.props.savePARQ }
							deletePARQ = { this.props.deletePARQ }
							fetchBodyMatrixMetas = {this.props.fetchBodyMatrixMetas}
							fetchBodyMatrixRanges = {this.props.fetchBodyMatrixRanges}
							deleteBodyMatrixRange = {this.props.deleteBodyMatrixRange}
							fetchWeightMetricRanges = { this.props.fetchWeightMetricRanges }
							saveWeightMatric = {this.props.saveWeightMatric}
							deleteWeightMetricRange = {this.props.deleteWeightMetricRange}
							fetchWeightMetric =  {this.props.fetchWeightMetric}
							saveClientAction = {this.props.saveClientAction}
							saveMileStones = { this.props.saveMileStones }
							deleteMileStones = { this.props.deleteMileStones }
							updateActionStatus = { this.props.updateActionStatus }
							saveScheduleCall = { this.props.saveScheduleCall }
							deleteActionRange = { this.props.deleteActionRange }
							deleteAction = { this.props.deleteClientAction }
							fetchActionRanges = { this.props.fetchActionRanges }
							fetchBodyMatrix = {this.props.fetchBodyMatrix}
							user = { this.props.user }
							isLoadMore = { clientType === 'clients' ? this.props.isClientsLoadMore : this.props.isGroupsLoadMore  }
						/>
					</div>

				</div>
			</div>
		);
	}
}

export default ClientsForm;



// WEBPACK FOOTER //
// ./src/components/assignments/MobileClientsForm.js